import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;

  > div {
    min-width: 270px;
    max-width: 400px;
    width: 100%;

    small {
      color: #6b6b6b;
    }

    select {
      border: none;
      border-bottom: 1px solid #7c7c7c;
      color: #ababab;
      font-size: 90%;
    }

    .btn-pagination {
      color: #a0a0a0;
      font-family: 'Roboto';
      font-size: 16px;
      font-weight: 600;
      padding: 0 7px;
    }
    .selected {
      background-color: #002f6c;
      color: #fff;
      border-radius: 4px;
    }
  }

  @media screen and (min-width: 992px) {
    padding: 0 10px;
    > div .btn-pagination {
      font-size: 20px;
      margin: 0 10px;
    }

    > div {
      min-width: 320px;
      max-width: 400px;
      width: 100%;
    }
  }
`;
